import { en } from "./en";
import { fr } from "./fr";

export const translations = {
  en,
  fr,
};
